<script setup>
  import AppSidebar from "@/components/App/Sidebar/AppSidebar.vue";
  import { computed, ref } from "vue";
  import { Settings, Target } from "lucide-vue-next";
  import { useRoute } from "vue-router";
  import { storeToRefs } from "pinia";
  import { useCurrentUserStore } from "@stores/currentUser.js";
  import { useTemplateStore } from "@stores/mailing/template.js";

  const { canWriteSurveys } = storeToRefs(useCurrentUserStore());
  const templateStore = useTemplateStore();
  const { template } = storeToRefs(templateStore);

  const token = computed(() => template.value?.token);

  const route = useRoute();

  const hasEditRole = computed(() => canWriteSurveys.value);

  const navigation = computed(() => [
    {
      title: "Create",
      isOpen: ref(true),
      items: [
        {
          title: "Settings",
          url: `/mailing/templates/${token.value}/setup`,
          icon: Settings,
          isActive: !!route.path.match(/^\/mailing\/templates\/(.*)\/setup/),
          if: hasEditRole,
        },
        {
          title: "Content",
          url: `/mailing/templates/${token.value}/edit`,
          icon: Target,
          isActive: !!route.path.match(/^\/mailing\/templates\/(.*)\/edit/),
          if: hasEditRole,
        },
      ],
    },
  ]);
</script>

<template>
  <AppSidebar
    :navigation="navigation"
    :back="{ label: 'Email templates', to: '/mailing/templates' }" />
</template>
